import React, { Fragment } from 'react'

import { useRouter } from 'next/router'

import CardView from '@nexys/components/CardView/CardView'
import { Button, Col, Row } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import moment from 'moment'
import { Title } from 'shortcuts/Typography'

import useGetAllArticle from 'data/useGetAllArticle'
import { getImagePath } from 'utils/imagePath'

import classNames from 'views/Home/partials/HighlightPost.module.scss'

const OurActivity = ({ articleData: articles }) => {
  const router = useRouter()

  const { xs, lg } = useBreakpoint()

  const { data: articleData = [], length } = useGetAllArticle(
    1,
    99,
    'main-banner',
    'filterType',
  )

  return (
    <Fragment>
      <Row
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: lg ? '80px' : '60px',
        }}
      >
        <Col lg={24}>
          <Row
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginBottom: '23px',
            }}
          >
            <Col>
              <Title
                style={{
                  // fontSize: sm ? '25px' : xs ? '25px' : '30px',
                  fontSize: xs ? '20px' : '36px',
                  color: '#2C2C2C',
                  fontFamily: 'Inter-Bold',
                  fontWeight: '700',
                }}
              >
                Kegiatan Kami
              </Title>
            </Col>
            {router.pathname !== '/announcement' && lg && (
              <Col>
                <Button
                  style={{ color: '#985ECF' }}
                  className={classNames.buttonDefault}
                  onClick={() => {
                    router.push('/information')
                  }}
                >
                  Lihat Semua
                </Button>
              </Col>
            )}
          </Row>
        </Col>
        <Col className={classNames.myActivity}>
          {router.pathname !== '/announcement'
            ? articleData?.map((dt) => {
                return (
                  <CardView
                    text={dt?.tittle}
                    type="activity"
                    paragraph={dt?.shortDesc}
                    author="Daniel"
                    withAuthor={false}
                    createdDate={moment(dt?.createdAt).format('Do MMMM YYYY')}
                    img={getImagePath(dt?.imagePath)}
                    onClick={() => {
                      router.push(`/kegiatan/${dt?.tittle}`)
                    }}
                  />
                )
              })
            : articleData
                ?.filter((d) => d?.type === 'none')
                ?.map((dt) => {
                  return (
                    <CardView
                      text={dt?.tittle}
                      type="activity"
                      paragraph={dt?.shortDesc}
                      author=""
                      createdDate={moment(dt?.createdAt).format('Do MMMM YYYY')}
                      img={getImagePath(dt?.imagePath)}
                      onClick={() => {
                        router.push(
                          `/information/${dt?.tittle.split(' ').join('-')}`,
                        )
                      }}
                    />
                  )
                })}
        </Col>
        {router.pathname !== '/announcement' && !lg && (
          <Col className="mx-auto mt-4">
            <Button
              style={{ color: '#985ECF' }}
              className={classNames.buttonDefault}
              onClick={() => {
                router.push('/kegiatan')
              }}
            >
              Lihat Semua
            </Button>
          </Col>
        )}
      </Row>
    </Fragment>
  )
}

export default OurActivity
